import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import type { DocumentFilterCondition } from '../../types';

const { RangePicker } = DatePicker;

interface NoteDateRangePickerProps {
    condition: DocumentFilterCondition;
    groupId: string;
    updateCondition: (groupId: string, conditionId: string, updates: Partial<DocumentFilterCondition>) => void;
}

/**
 * Date range picker for note date filtering
 */
export const NoteDateRangePicker: React.FC<NoteDateRangePickerProps> = ({ condition, groupId, updateCondition }) => {
    const handleDateRangeChange = (dates: any) => {
        if (dates && dates[0] && dates[1]) {
            updateCondition(groupId, condition.id, {
                value: [dates[0].toISOString(), dates[1].toISOString()],
            });
        } else {
            updateCondition(groupId, condition.id, {
                value: undefined,
            });
        }
    };

    return (
        <RangePicker
            className="!h-[32px] w-full"
            onChange={handleDateRangeChange}
            value={
                condition.value && Array.isArray(condition.value) && condition.value.length === 2
                    ? [
                          condition.value[0] ? dayjs(String(condition.value[0])) : null,
                          condition.value[1] ? dayjs(String(condition.value[1])) : null,
                      ]
                    : null
            }
        />
    );
};
